export default __webpack_public_path__ + "static/media/9.601b466b.png";